import { render, staticRenderFns } from "./pbbtransferfrm.vue?vue&type=template&id=f58c4f0a&"
import script from "./pbbtransferfrm.vue?vue&type=script&lang=js&"
export * from "./pbbtransferfrm.vue?vue&type=script&lang=js&"
import style0 from "./pbbtransferfrm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports